import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const barSx = {
  height: "100%",
  borderRadius: "100px",
  position: "absolute",
  top: 0,
  bottom: 0,
};
export const HubProgressBar = ({
  percent = 0,
  topColor = "hubColors.mainFocus",
  bottomColor = "hubColors.mainFocusLighter",
}) => {
  return (
    <Stack direction="row" gap="5px" alignItems="center" height="12px">
      <Stack sx={{ position: "relative", width: "100%", height: "10px" }}>
        <Box
          sx={{
            width: `${percent}%`,
            backgroundColor: topColor,
            ...barSx,
          }}
        />
        <Box
          sx={{
            width: "100%",
            backgroundColor: bottomColor,
            ...barSx,
          }}
        />
      </Stack>
      <Typography variant="caption11">{percent}%</Typography>
    </Stack>
  );
};

export default HubProgressBar;
